
export default function CTA() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-red-600 to-red-700">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-8 font-nunito">
            Une panne ? On arrive.
          </h2>
          
          <p className="text-xl md:text-2xl text-red-100 mb-12 max-w-3xl mx-auto font-nunito">
            Dépannage électrique d'urgence à Nantes et alentours. 
            Intervention rapide 7j/7 par un artisan électricien qualifié.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a
              href="tel:+33656847324"
              className="inline-flex items-center bg-white text-red-600 px-10 py-5 rounded-full font-bold text-xl hover:bg-stone-100 transition-colors shadow-lg whitespace-nowrap cursor-pointer font-nunito"
            >
              <i className="ri-phone-line mr-3 text-2xl"></i>
              06 56 84 73 24
            </a>
            
            <button
              onClick={scrollToContact}
              className="inline-flex items-center bg-transparent border-2 border-white text-white px-10 py-5 rounded-full font-bold text-xl hover:bg-white hover:text-red-600 transition-colors shadow-lg whitespace-nowrap cursor-pointer font-nunito"
            >
              <i className="ri-file-text-line mr-3 text-2xl"></i>
              Demander un devis
            </button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2 font-nunito">Intervention rapide</h3>
              <p className="text-red-100 font-nunito">~30 minutes selon disponibilité</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2 font-nunito">Garantie qualité</h3>
              <p className="text-red-100 font-nunito">Assurance décennale pro</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-24-hours-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2 font-nunito">Service 7j/7</h3>
              <p className="text-red-100 font-nunito">Disponible même le weekend</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
